import { useContext, useState } from 'react';
import { OrderContext } from '../context/OrderContext';

const usePhotoUpload = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const MAX_FILE_SIZE_MB = 5;

  const {apiClient, uuid} = useContext(OrderContext);

  const uploadFile = async (file, product_id) => {
    if (!uuid) {
      const msg = 'Iade kaydi bulunamadi. Lutfen tekrar deneyin.';
      setError(msg);
      throw new Error(msg);
    }

    const maxFileSize = MAX_FILE_SIZE_MB * 1024 * 1024;
    if (!file || file.size === 0) {
      const msg = 'Dosya bos olamaz.';
      setError(msg);
      throw new Error(msg);
    }
    if (file.size > maxFileSize) {
      const msg = `Dosya boyutu en fazla ${MAX_FILE_SIZE_MB} MB olabilir.`;
      setError(msg);
      throw new Error(msg);
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('order_product_id', product_id);

    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.post(`api/v1/refund/${uuid}/upload_document/`, formData);
      return response.data;

    } catch (err) {
      const status = err.response?.status;
      let msg = err.response?.data?.error || err.response?.data?.detail;

      if (!msg && status === 413) {
        msg = `Dosya boyutu en fazla ${MAX_FILE_SIZE_MB} MB olabilir.`;
      } else if (!msg && err.code === 'ERR_NETWORK') {
        msg = file.size > maxFileSize
          ? `Dosya boyutu en fazla ${MAX_FILE_SIZE_MB} MB olabilir.`
          : 'Ag hatasi olustu. Lutfen tekrar deneyin.';
      } else if (!msg) {
        msg = err.message || 'API error';
      }

      setError(msg);
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  };

  return { uploadFile, loading, error };
};

export default usePhotoUpload;
